import ApolloClient from "apollo-boost";
import CONFIG from '../medisource/config';
import AuthService from '../medisource/AuthService';

var auth_service = new AuthService();
const client = new ApolloClient({
    uri: CONFIG.API + "/api/",
    request: operation => {
        // console.log("APOLLO REQUEST OPERATION", operation);

        if (operation.variables.hasOwnProperty("skipAuthorization") && operation.variables.skipAuthorization === true) {

            // do not proceed to authorization process
            return
        }

        const accessToken = "JWT "+ auth_service.getToken();
        operation.setContext({ headers: { authorization: accessToken } });
    }
});


export default client
